import React, { useCallback, useEffect, useState } from "react";
import dataAnimation from "../../assets/lottie/Servisor_09_Confirmation_1.json";
import servisorIcon from "../../assets/servisorWhiteLogo.png";
import "./Workshop.scss";
import Gear from "../../assets/icon-service.svg";
import Calendar from "../../assets/icons/calendar.svg";
import Calculator from "../../assets/icons/calculator.svg";
import NextIcon from "../../assets/icons/ChevronRightFilled.svg";
import { Redirect, RouteComponentProps, useHistory } from "react-router";
import { uuidFetch } from "../../services/apis/workshop.service";
import { getSelectedWorkshopById } from "../../services/apis/worksshopsData.service";
import { formatDate } from "../../services/utilities/dateFormating";
import { ConditionalInfoCard } from "./components/ConditionalCardInfo";
import { ConditionalServiceCard } from "./components/CondtionalDetailsCard";
import personalTag from "../../assets/tags/bookingdetailsnew.svg";
import {
  Backdrop,
  BottomNavigation,
  Box,
  Button,
  CircularProgress,
  Container,
  Fade,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import { HeaderText } from "../../components/common/HeaderText";
import { createPayment } from "../../services/apis/api.service";
import { PageLayout } from "../../components/layout/PageLayout";
import { SubHeaderText } from "../../components/common/SubHeaderText";

interface ResultProps
  extends RouteComponentProps<{
    id: string;
  }> {}

const ConditionalWorkshop: React.FC<ResultProps> = () => {
  const [clicked, setClicked] = useState(false);
  const [activeBrand, setActiveBrand]: any = useState(null);
  const [uuidData, setUuidData] = useState("");
  const [workshopData, setWorkshopData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [urlData, setUrlData] = useState("");
  const history = useHistory();

  useEffect(() => {
    setActiveBrand("../../assets/nissan.svg");
  }, []);

  const currUrl = window.location.href;
  const urlParts = currUrl.split("/");
  const urlId = urlParts[urlParts.length - 1];

  const selectedWorkshopDetails = JSON.parse(
    localStorage.getItem("selected-workshop-details") ?? "",
  );

  const maintenanceDetails = JSON.parse(
    localStorage.getItem("maintenance-details") ?? "",
  );

  const marketPriceFetch = JSON.parse(
    localStorage.getItem("maintenance-details") ?? "",
  );

  const customise = JSON.parse(localStorage.getItem("servicesInfo") ?? "");

  const selectedWorkshop = selectedWorkshopDetails?.data.find(
    (workshop: any) => workshop._id === urlId,
  );

  const marketPrice = Number(maintenanceDetails?.market_price);

  const discountPercentage = selectedWorkshop?.percentage_saved;
  const discountedWorkshopPrice = selectedWorkshop?.discounted_workshop_price;
  const adminFee = selectedWorkshop?.service_fee;
  const workshopTotalFee = Number(discountedWorkshopPrice) + Number(adminFee);

  const totalFee = workshopTotalFee.toFixed(2);

  const findWorkShop = useCallback(() => {
    setIsLoading(true);
    getSelectedWorkshopById(urlId).then((response) => {
      setWorkshopData(response.data);
      setIsLoading(false);
    });
  }, [urlId]);

  useEffect(() => {
    findWorkShop();
  }, [findWorkShop]);

  useEffect(() => {
    async function fetchUuid() {
      try {
        const data = await uuidFetch();
        setUuidData(data.uuid);
        localStorage.setItem("uuid-data", JSON.stringify(data.data));
      } catch (error) {
        console.error("Something went wrong fetching the uuid:", error);
      }
    }
    fetchUuid();
  }, []);

  localStorage.setItem("uuid-data", JSON.stringify(uuidData));

  const serviceDetails = JSON.parse(localStorage.getItem("servicesInfo") ?? "");
  const details = JSON.parse(localStorage.getItem("details-evaluation") ?? "");
  localStorage.setItem("urlId", JSON.stringify(urlId));

  const payBooking = async () => {
    setShowModal(true);
    try {
      const data = {
        amount: totalFee.toString(),
        email: details?.email,
        name: details?.name,
        uuid: uuidData,
        mobile: details?.phonenumber,
        surname: details?.surname,
        workshop_id: urlId,
      };
      const result = await createPayment(data);
      setUrlData(result);
    } catch (error) {
      console.error(error);
      setShowModal(false);
    }
  };

  return (
    <PageLayout animationData={dataAnimation}>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75%",
            mt: 16,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {" "}
          <HeaderText headerText="WORKSHOPS" headerImage={servisorIcon} />
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
            disableEscapeKeyDown
            open={showModal}
          >
            <Fade in={showModal}>
              <Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: {
                      xs: "90%",
                      lg: "50%",
                    },
                    height: "80%",

                    backgroundColor: "#FFF",
                    borderRadius: "8px",
                    boxShadow: "24",
                    padding: "24px 16px",
                  }}
                >
                  {urlData ? (
                    <iframe
                      src={urlData}
                      width="100%"
                      height="100%"
                      title="pay"
                      style={{ border: "none" }}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      {urlData === null ? (
                        <Typography variant="body1">
                          Something went wrong. Please try again later.
                        </Typography>
                      ) : (
                        <CircularProgress />
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            </Fade>
          </Modal>
          <Box
            sx={{
              overflow: "auto",
              maxHeight: "calc(100vh - 64px)",

              backgroundColor: "#EAEDF6",
              paddingBottom: "100px",
              paddingTop: { xs: "80px", lg: "100px" },
            }}
          >
            <>
              <Container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  width: { xs: "90%", lg: "544px" },
                }}
                disableGutters
              >
                <Box
                  sx={{
                    display: { xs: "none", lg: "flex" },
                    width: "544px",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", lg: "flex" },
                      alignSelf: "center",
                      width: { xs: "100%" },
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <img src={personalTag} alt="/" />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "16px",
                      }}
                    >
                      <Button
                        onClick={() =>
                          history.push(
                            `/results/${customise.distance}/${customise.service_date}/${marketPriceFetch.market_price}`,
                          )
                        }
                        sx={{
                          padding: "8px",
                          marginBottom: "18px",
                          display: "flex",
                          borderRadius: "10%",
                          justifyContent: "center",
                          backgroundColor: "#d1ddf8",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={NextIcon}
                            alt="/"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                              transform: "rotate(180deg)",
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#002064",
                            fontWeight: "500",
                            textTransform: "none",
                          }}
                        >
                          Back
                        </Typography>
                      </Button>
                    </Box>
                  </Box>

                  <Box>
                    <SubHeaderText headerText="Your booking details:" />
                  </Box>
                </Box>
                <Box
                  sx={{
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    height: "64px",
                    alignItems: "center",
                    borderRadius: "4px",
                    padding: "16px",
                    width: { xs: "100%", lg: "544px" },

                    background: "#FFF",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "2px",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <img src={Calculator} alt="/" />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#101828",
                      }}
                    >
                      Market Related Price:
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#101828",
                      }}
                    >
                      R {marketPrice}
                    </Typography>
                  </Box>
                </Box>
              </Container>

              <Container
                disableGutters
                sx={{
                  paddingTop: "20px",
                  width: { xs: "90%", lg: "544px" },
                  display: "flex",
                  gap: "15px",
                  flexDirection: "column",
                }}
              >
                <ConditionalInfoCard
                  workshop={workshopData}
                  discountPercentage={discountPercentage}
                />
                <ConditionalServiceCard
                  activeBrand={activeBrand}
                  Gear={Gear}
                  maintenanceDetails={maintenanceDetails}
                  adminFee={adminFee}
                  discountedWorkshopPrice={discountedWorkshopPrice}
                />

                <Box>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#101828",
                    }}
                  >
                    Additional Details
                  </Typography>
                </Box>
                <Box
                  sx={{
                    padding: "16px",
                    borderRadius: "4px",
                    backgroundColor: "#FFF",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <img src={Calendar} className="gear-icon" alt="/" />
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#101828",
                        }}
                      >
                        Service Date
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#101828",
                        }}
                      >
                        {formatDate(serviceDetails.service_date)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Container>

              <Paper
                sx={{
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  zIndex: "99",
                  paddingY: "20px",
                  width: { xs: "100%", lg: "50%" },
                  borderRadius: "0",
                }}
                elevation={0}
              >
                <BottomNavigation>
                  <Box
                    sx={{
                      display: "flex",
                      width: { xs: "100%", lg: "100%" },
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      type="submit"
                      fullWidth
                      sx={{
                        height: "60px",
                        paddingY: "10px",
                        width: {
                          xs: "90%",
                          lg: "544px",
                        },
                        backgroundColor: "#004FFA",
                        ":hover": {
                          backgroundColor: "#002064",
                        },
                      }}
                      variant="contained"
                      onClick={payBooking}
                    >
                      <Typography
                        textTransform="none"
                        sx={{
                          color: "#FFF",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                      >
                        Secure Booking
                      </Typography>
                      {clicked ? <CircularProgress></CircularProgress> : null}
                    </Button>
                  </Box>
                </BottomNavigation>
              </Paper>
            </>
          </Box>
        </>
      )}
    </PageLayout>
  );
};

export default ConditionalWorkshop;
